/**
 * before to publish:
 * 1-check the mode!
 * 2-check the endpoint!
 * 
 * mode production:  publish = true;      userTest = false;
 * mode test:        publish = true;      userTest = true;
 * mode development: publish = false ;    userTest = true;
 */

var publish = true;
var userTest = false;
var endpoint = 'production';
//production publish on pre-production domain to be tested before production
const preprod = false;

export const Config = {
  name: 'websci',
  version: require('../package.json').version,
  //endpoint: endpoint,
  merchantURL: userTest ? 'https://user-test.mypass.ski/proxy.php?csurl=https://services.mypass.technology/sella/merchant_2.php' : 'https://user.mypass.ski/proxy.php?csurl=https://services.mypass.technology/sella/merchant_2.php',
  //https://user-test.mypass.ski/merchant_mypass_sci_2_web.html
  test:preprod? '0': endpoint == "production" ? "0" : "1",	// 1 -> test, 0 -> production version
  publish: publish, // true -> publishment, false -> development & debugging
  userTest: userTest,
  preprod: preprod,
  hostUrl:
    preprod ? 'https://user-preprod.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI/v1/' :
      publish ?
        endpoint == "production" ?
          (userTest ? 'https://user-test.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI/v1/' : 'https://user.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI/v1/') :
          (userTest ? 'https://user-test.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI.test/sci/' : 'https://user.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI.test/sci/')
        :
        'https://services.mypass.technology/MPLumenAPI.test/sci/',

  preferredCountry: 'it',
  platform: 'web',
  portal: 'sci',
  bank: {
    test:preprod? "0": endpoint == "production" ? "0" : "1",
    portal: 'sci',
    shopLogin:preprod? "9095024":  endpoint == "production" ? '9095024' : 'GESPAY65084',
  },
};

export const firebaseConfig_test = {
  apiKey: "AIzaSyDFQpwCCuC7W1sqKyj5JqHsqJt68dRf1iE",
  authDomain: "mypass-sci-test.firebaseapp.com",
  databaseURL: "https://mypass-sci-test.firebaseio.com",
  projectId: "mypass-sci-test",
  storageBucket: "mypass-sci-test.appspot.com",
  messagingSenderId: "535537017727",
  appId: "1:535537017727:web:94a96b9feb68d48083b04a",
  measurementId: "G-C59EP89QB9"
};
export const firebaseConfig = {
  apiKey: "AIzaSyBQMT_8rkPuL5vuUMG7wUk0CqrzBIhRYLs",
  authDomain: "mypassci.firebaseapp.com",
  databaseURL: "https://mypassci.firebaseio.com",
  projectId: "mypassci",
  storageBucket: "mypassci.appspot.com",
  messagingSenderId: "74796121765",
  appId: "1:74796121765:web:a0b99b83ff0bfc7019974c",
  measurementId: "G-BY8TSQRE57"
};



// WEBPACK FOOTER //
// ./src/Config.js